var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 14,
    viewBox: "0 0 21 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7885 3.31543C10.5685 3.31543 9.57812 4.30506 9.57812 5.52577C9.57812 6.74648 10.5685 7.73681 11.7885 7.73681C13.0099 7.73681 13.9988 6.74718 13.9988 5.52577C13.9988 4.30436 13.0092 3.31543 11.7885 3.31543ZM11.7885 6.99933C10.9765 6.99933 10.3149 6.33841 10.3149 5.52507C10.3149 4.71173 10.9758 4.05151 11.7885 4.05151C12.6018 4.05151 13.262 4.71243 13.262 5.52507C13.262 6.3377 12.6011 6.99933 11.7885 6.99933Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.94727 0V11.0517H20.63V0H2.94727ZM19.8939 2.49269V10.3149H3.68475V0.73678H19.8939V2.49269Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6784 11.7895H2.21041V1.47461H1.47363V12.5263H19.1571V11.7895H18.4203H16.6784Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2048 13.2632H0.73678V2.94824H0V13.9999H17.6834V13.2632H16.9466H15.2048Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.78955 1.49707H6.99989V2.23385H4.78955V1.49707Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.78955 8.8418H6.99989V9.57858H4.78955V8.8418Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5781 1.49707H18.7885V2.23385H16.5781V1.49707Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5781 8.8418H18.7885V9.57858H16.5781V8.8418Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayoutIcon);
export default __webpack_public_path__ + "static/media/payoutIcon.0329ebdc54bf7beb47a786dd3c217098.svg";
export { ForwardRef as ReactComponent };